module.exports = __webpack_public_path__ + "img/08.18d5407e.jpg";